import React, { Component } from "react";
import EntryForm2 from "../../components/EntryForms/EntryForm2/EntryForm2";
import axiosInstance from "../../api/utils/axiosInstance";
import {
  formSubmitSuccess,
  formSubmitError,
} from "../../store/actions/forms/formActions";
import { connect } from "react-redux";
import {
  handleUserInput,
  handleMappedUserInput,
} from "../../helperFunctions/EntryFormHelperFunctions/userInputHandlers";
import {
  handleCountryAutocomplete,
  countryAutocompleteHandler,
  countyAutocompleteHandler,
  cityAndMuncipalityAutocomplete,
  districtAutocompleteHandler,
} from "../../helperFunctions/EntryFormHelperFunctions/autocompleteHelpers";
import { handleDayPicker } from "../../helperFunctions/EntryFormHelperFunctions/datePickerHelper";
import {
  validateRequiredFields,
  validateArrayFields,
} from "../../helperFunctions/validationHelpers/validateRequiredFields";
import Spinner from "../../components/UI/Spinner/Spinner";
import fetchFormsApi from "../../api/formsApi/fetchFormsApi";
import { purgeUpdateAndRedirect } from "../../helperFunctions/purgeUpdateAndRedirect";
import { PURGE_UPDATE } from "../../constants/constants";

class RegistarSamostalnihRevizora extends Component {
  state = {
    error: false,
    update: false,
    loader: false,
    requestsLoaded: false,
    countryList: [],
    countyList: [],
    cityAndMuncipalityList: [],
    districtList: [],
    newFormData: {
      oznDokumenta: {
        oznDokumenta: "",
      },
      userData: {
        vrDrustva: "2",
        oib: "",
        ime: "",
        oznAkt: "",
        prezime: "",
        regBroj: "",
        mbr: "",
        requiredFieldsUserData: ["oib", "ime", "prezime", "mbr"],
        tstampUnosa: null,
      },
      address: {
        vrAdr: "1",
        sifDrzave: "191",
        sifZupanije: "",
        nazZupanije: "",
        sifGrdOpc: "",
        nazGrdOpc: "",
        sifNaselja: "",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        permitNumber: "",
        permitDate: "",
        requiredFieldsAddress: [
          "nazNaselja",
          "sifNaselja",
          "nazZupanije",
          "sifZupanije",
          "sifDrzave",
          "permitDate",
          "permitNumber",
        ],
      },
      contactInformation: [
        {
          ime: "",
          prezime: "",
          telefon: "",
          web: "",
          email: "",
          emailValidated: false,
          id: 1,
        },
      ],

      officeAddress: [
        {
          vrAdr: 2,
          ulicaKbr: "",
          nazNaselja: "",
          brPoste: "",
          nazivDrzave: "",
          sifDrzave: "191",
          id: 1,
        },
      ],
      basicReviserData: [
        {
          oib: "",
          prezime: "",
          ime: "",
          regBroj: "",
          idOsobe: "",
          id: 1,
          // requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: false,
        },
      ],
      reviserRegForeignCountry: [
        {
          vrRegistracije: "2",
          brReg: "",
          nazTijela: "",
          datReg: "",
          sifDrzave: "191",
          brPoste: "",
          ulicaKbr: "",
          nazNaselja: "",
          id: 1,
        },
      ],
      thirdCountryRegistration: [
        {
          vrRegistracije: "3",
          brReg: "",
          nazTijela: "",
          datReg: "",
          sifDrzave: "191",
          brPoste: "",
          ulicaKbr: "",
          nazNaselja: "",
          id: 1,
        },
      ],
      competentBodyData: [
        {
          vrRegistracije: "4",
          nazTijela: "",
          sifDrzave: "191",
          nazNaselja: "",
          brPoste: "",
          ulicaKbr: "",
          id: 1,
        },
      ],
      mjere: [],
    },
  };

  componentDidMount = () => {
    this.getCountryList();
  };

  getDrustvoEdit = async (oznaka) => {
    const { idDrustva, vrDrustva } = this.props;

    const { data } = await axiosInstance.get(
      `/findDrustvo?idDrustva=${idDrustva}&vrDrustva=${vrDrustva}&showHistory=false`
    );

    const findAddress = data[2].find((element) => element.vrAdr == 1);

    const findAddressRegistration = data[3].find(
      (element) => element.vrRegistracije == 1
    );

    const address = {
      vrAdr: "1",
      sifDrzave: String(findAddress?.sifDrzave || ""),
      sifZupanije: String(findAddress?.sifZupanije || ""),
      nazZupanije: findAddress?.nazZupanije,
      sifGrdOpc: String(findAddress?.sifGrdOpc || ""),
      nazGrdOpc: findAddress?.nazGrdOpc,
      sifNaselja: String(findAddress?.sifNaselja || ""),
      nazNaselja: findAddress?.nazNaselja || "",
      brPoste: findAddress?.brPoste || "",
      ulicaKbr: findAddress?.ulicaKbr || "",
      permitNumber: findAddressRegistration?.brReg || "",
      permitDate: findAddressRegistration?.datReg || "",
      requiredFieldsAddress: [
        "nazNaselja",
        "sifNaselja",
        "nazZupanije",
        "sifZupanije",
        "sifDrzave",
        "permitDate",
        "permitNumber",
      ],
    };

    const officeAddress = data[2]
      .filter((element) => element.vrAdr == 2)
      .map((element, index) => {
        return {
          vrAdr: 2,
          ulicaKbr: element.ulicaKbr || "",
          nazNaselja: element.nazNaselja || "",
          brPoste: element.brPoste || "",
          nazivDrzave: element.drzava || "",
          id: index + 1,
          sifDrzave: String(element?.sifDrzave || ""),
        };
      });

    if (+address.sifZupanije) {
      this.getCityAndMuncipalityList(address.sifZupanije);
    }

    if (+address.sifGrdOpc) {
      this.getDistrictList(address.sifGrdOpc);
    }

    const findReviserRegForeignCountry = data[3].filter(
      (element) => element.vrRegistracije == 2
    );

    let reviserRegForeignCountry;
    if (findReviserRegForeignCountry.length > 0) {
      reviserRegForeignCountry = findReviserRegForeignCountry.map(
        (element, index) => {
          return {
            vrRegistracije: "2",
            nazTijela: element?.nazTijela || "",
            sifDrzave: String(element?.sifDrzave || ""),
            brPoste: element?.brPoste || "",
            ulicaKbr: element?.ulicaKbr || "",
            nazNaselja: element?.nazNaselja || "",
            brReg: element?.brReg || "",
            datReg: element?.datReg || "",
            id: index + 1,
          };
        }
      );
    } else {
      reviserRegForeignCountry =
        this.state.newFormData.reviserRegForeignCountry;
    }

    const findThirdCountryRegistration = data[3].filter(
      (element) => element.vrRegistracije == 3
    );

    let thirdCountryRegistration;
    if (findThirdCountryRegistration.length > 0) {
      thirdCountryRegistration = findThirdCountryRegistration.map(
        (element, index) => {
          return {
            vrRegistracije: "3",
            nazTijela: element?.nazTijela || "",
            sifDrzave: String(element?.sifDrzave || ""),
            brPoste: element?.brPoste || "",
            ulicaKbr: element?.ulicaKbr || "",
            nazNaselja: element?.nazNaselja || "",
            brReg: element?.brReg || "",
            datReg: element?.datReg || "",
            id: index + 1,
          };
        }
      );
    } else {
      thirdCountryRegistration =
        this.state.newFormData.thirdCountryRegistration;
    }

    const findCompetentBodyData = data[3].filter(
      (element) => element.vrRegistracije == 4
    );

    let competentBodyData;
    if (findCompetentBodyData.length > 0) {
      competentBodyData = findCompetentBodyData.map((element, index) => {
        return {
          vrRegistracije: "4",
          nazTijela: element?.nazTijela || "",
          sifDrzave: String(element?.sifDrzave || ""),
          nazNaselja: element?.nazNaselja || "",
          brPoste: element?.brPoste || "",
          ulicaKbr: element?.ulicaKbr || "",
          id: index + 1,
        };
      });
    } else {
      competentBodyData = this.state.newFormData.competentBodyData;
    }

    //contactInformation
    const contactInformation = data[4].map((element, index) => {
      return {
        ime: element?.ime || "",
        prezime: element?.prezime || "",
        telefon: element?.telefon || "",
        web: element?.web || "",
        email: element?.email || "",
        emailValidated: true,
        id: index + 1,
      };
    });

    //basicReviserData
    let basicReviserData;

    if (data[5].length > 0) {
      basicReviserData = data[5].map((element, index) => {
        return {
          oib: element?.oibIdBrojOsobe || "",
          prezime: element?.prezimeOsobe || "",
          ime: element?.imeOsobe || "",
          regBroj: element?.regBrojOsobe || "",
          idOsobe: element?.idOsobe || "",
          // requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
          oibValidated: true,
          id: index + 1,
        };
      });
    } else {
      basicReviserData = this.state.newFormData.basicReviserData;
    }

    let oznDokumenta = {};

    if (oznaka) {
      oznDokumenta.oznDokumenta = oznaka;
    } else {
      oznDokumenta.oznDokumenta = data[6].oznDokumenta;
    }

    this.setState((prevState) => ({
      update: true,
      requestsLoaded: true,
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          oznAkt: data[1]?.oznAkt || "",
          idDrustva: data[1]?.idDrustva || "",
          oib: data[1]?.oib || "",
          ime: data[1]?.ime || "",
          mbr: String(data[1]?.mbr || ""),
          prezime: data[1]?.prezime || "",
          regBroj: data[1]?.regBroj || "",
          oibValidated: true,
          tstampUnosa: data[1].tstampUnosa,
        },
        address,
        contactInformation,
        officeAddress,
        reviserRegForeignCountry,
        thirdCountryRegistration,
        competentBodyData,
        basicReviserData,
        oznDokumenta,
        mjere: data[7],
      },
    }));
  };

  getCountryList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/drzave");
    this.setState(
      {
        countryList: data,
      },
      () => {
        this.getCountyList();
      }
    );
  };

  checkIfUpdate = (url) => {
    return this.props.match.url.includes(url);
  };

  getCountyList = async () => {
    const { data } = await axiosInstance.get("/sifarnici/zupanije");

    this.setState(
      {
        countyList: data,
      },
      () => {
        if (this.checkIfUpdate("/azuriraj/registar-samostalnih-revizora")) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          this.getDrustvoEdit();
        } else if (
          this.checkIfUpdate(
            "/azuriraj-po-zahtjevu/registar-samostalnih-revizora"
          )
        ) {
          if (this.props.idDrustva != this.props.match.params.id) {
            const { purgeUpdate, history } = this.props;
            purgeUpdateAndRedirect(purgeUpdate, () =>
              history.push("/pregled-registara")
            );
            return;
          }
          const oznDokumenta = this.props.oznDokumenta;
          this.getDrustvoEdit(oznDokumenta);
        } else {
          this.getDataFromUnosZahtjeva();
        }
      }
    );
  };

  getDataFromUnosZahtjeva = async () => {
    const { data } = await fetchFormsApi(
      `/request/${this.props.zahtjevAtrId}?isEdit=${false}`
    );

    const findObjectByLabel = (label) => {
      const findLabel = data.groupList.map((el) =>
        el.controlList.find((element) => element.controlLabel == label)
      );
      return findLabel;
    };

    const findCountry = findObjectByLabel("Naziv države");

    const findCity = findObjectByLabel("Naziv grada");

    const findDistrict = findObjectByLabel("Naziv mjesta");

    const findbrPoste = findObjectByLabel("Poštanski broj");

    const findUlica = findObjectByLabel("Ulica");

    const findKucniBr = findObjectByLabel("Kućni broj");

    const ulicaKbr = `${findUlica[0].value} ${findKucniBr[0].value}`;

    const brPoste = findbrPoste[0].value;

    const findImeKontakt = findObjectByLabel("Ime glavne osobe za kontakt");

    const findPrezimeKontakt = findObjectByLabel(
      "Prezime glavne osobe za kontakt"
    );

    const findTel = findObjectByLabel("Telefon/mob");

    const findEmail = findObjectByLabel("E-mail");

    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let emailValidated;

    if (findEmail[0].value.length > 0) {
      emailValidated = regexp.test(findEmail[0].value);
    } else {
      emailValidated = true;
    }

    const contactInformation = [
      ...this.state.newFormData.contactInformation.map((element) => {
        return (
          element.id == 1 && {
            ...element,
            ime: findImeKontakt[0].value || "",
            prezime: findPrezimeKontakt[0].value || "",
            telefon: findTel[0].value || "",
            // web: findWeb[0].value || "",
            email: findEmail[0].value || "",
            emailValidated,
          }
        );
      }),
    ];

    let sifZupanije;
    let nazZupanije;
    let sifGrdOpc;
    let nazGrdOpc;
    let cityAndMuncipalityList;
    let districtList;
    let nazNaselja;
    let sifNaselja;
    let getDistrictList;

    if (findCountry[0].value == 191 && findCity[0].value != "") {
      const response = await axiosInstance.get(
        `/sifarnici/grad/${findCity[0].value}`
      );
      sifZupanije = response.data.sifZupanije.toString();
      nazZupanije = response.data.nazZupanije;
      sifGrdOpc = findCity[0].value;

      const getCityList = await axiosInstance.get(
        `/sifarnici/gradOpcina/${sifZupanije}`
      );
      cityAndMuncipalityList = getCityList.data;

      getDistrictList = await axiosInstance.get(
        `/sifarnici/naselja/${sifGrdOpc}`
      );
      districtList = getDistrictList.data;
      const findNazivGrada = getCityList.data.filter((element) =>
        element.gradoviOpcine.find((el) => el.sifGrdOpc == sifGrdOpc)
      );

      nazGrdOpc = findNazivGrada[0].gradoviOpcine[0].nazGrdOpc;

      sifNaselja = findDistrict[0].value;

      const findNazivNaselja = getDistrictList.data.filter((element) =>
        element.naselja.find((el) => el.sifNaselja == sifNaselja)
      );

      if (findNazivNaselja.length > 0) {
        nazNaselja = findNazivNaselja[0].naselja[0].nazNaselja;
      } else {
        nazNaselja = findDistrict[0].value;
        sifNaselja = "";
      }
    } else {
      nazZupanije = "";
      sifZupanije = "";
      nazGrdOpc = findCity[0].value;
      cityAndMuncipalityList = [];
      districtList = [];
      nazNaselja = findDistrict[0].value;
      sifGrdOpc = "";
      sifNaselja = "";
      districtList = [];
    }

    const address = {
      ...this.state.newFormData.address,
      sifDrzave: findCountry[0].value,
      sifZupanije,
      nazZupanije,
      sifGrdOpc,
      nazGrdOpc,
      nazNaselja,
      sifNaselja,
      brPoste: brPoste || "",
      ulicaKbr: ulicaKbr || "",
    };

    this.setState(
      (prevState) => ({
        districtList,
        cityAndMuncipalityList,
        newFormData: {
          ...prevState.newFormData,
          userData: {
            ...prevState.newFormData.userData,
            oibValidated: true,
            oib: data.oib,
            ime: data.ime,
            prezime: data.prezime,
          },
          address,
          contactInformation,
        },
      }),
      () => {
        this.disableLoader();
      }
    );
  };

  disableLoader = () => {
    this.setState({
      requestsLoaded: true,
    });
  };

  getCityAndMuncipalityList = async (countyId) => {
    const { data } = await axiosInstance.get(
      `/sifarnici/gradOpcina/${countyId}`
    );

    this.setState({
      cityAndMuncipalityList: data,
    });
  };

  getDistrictList = async (id) => {
    const { data } = await axiosInstance.get(`/sifarnici/naselja/${id}`);

    this.setState({ districtList: data });
  };

  userInputHandler = (e, objData) => {
    e.persist();
    if (e.target.name === "mbr" && String(e.target.value.length) == 10) {
      return;
    }

    const isEmail = e.target.id === "email";
    // const id = e.target.id.replace(/[0-9]/g, "");
    const { name } = e.target;
    this.setState(handleUserInput(e, objData), () => {
      name === "oib" &&
        this.state.newFormData.userData.oibValidated &&
        this.fetchUserDataCoib();
      isEmail && this.validateEmail(e, objData);
    });
  };

  validateEmail = (e, objectData) => {
    const value = e.target.value;
    const regexp =
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailValidated = regexp.test(value);
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objectData.group]: [
          ...prevState.newFormData[objectData.group].map((element) =>
            element.id === objectData.id
              ? {
                ...element,
                emailValidated,
              }
              : element
          ),
        ],
      },
    }));
  };

  fetchUserDataCoib = async () => {
    const oib = this.state.newFormData.userData.oib;
    const { data } = await axiosInstance.get(`/sifarnici/oib-data/${oib}`);
    //ovo smece treba testirati
    const sifGradOpcina = data.sifraGradaOpcine.replace(/^0+/, "");
    const sifraNaselja = data.sifraNaselja.replace(/^0+/, "");

    this.getCityAndMuncipalityList(data.sifraZupanije);
    this.getDistrictList(sifGradOpcina);

    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        userData: {
          ...prevState.newFormData.userData,
          ime: data.ime,
          prezime: data.prezime,
        },
        address: {
          ...prevState.newFormData.address,
          sifDrzave: data.sifraDrzave,
          sifZupanije: data.sifraZupanije,
          nazZupanije: data.nazivZupanije,
          sifGrdOpc: sifGradOpcina,
          nazGrdOpc: data.grad,
          sifNaselja: sifraNaselja,
          nazNaselja: data.naselje,
          brPoste: data.postanskiBroj,
          ulicaKbr: `${data.adresa} ${data.kucniBroj} ${data.kucniBrojDodatak}`,
        },
      },
    }));
  };
  setCountryAutocompleteHandler = (values, objectData) => {
    this.setState(handleCountryAutocomplete(values, objectData));
  };

  autocompleteCountryHandler = (values, objectData) => {
    this.setState(countryAutocompleteHandler(values, objectData));
  };

  autocompleteCountyHandler = (values, objectData) => {
    this.setState(
      countyAutocompleteHandler(
        values,
        objectData,
        this.getCityAndMuncipalityList
      )
    );
  };

  autocompleteCityHandler = (values, objectData) => {
    this.setState(
      cityAndMuncipalityAutocomplete(values, objectData, this.getDistrictList)
    );
  };

  autocompleteDistrictHandler = (values, objectData) => {
    const stateCopy = this.state;

    this.setState(districtAutocompleteHandler(values, objectData), () => {
      if (
        stateCopy.newFormData[objectData.formGroup].hasOwnProperty("brPoste") &&
        values != null
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.formGroup]: {
              ...prevState.newFormData[objectData.formGroup],
              brPoste: String(values.brPoste),
            },
          },
        }));
      }
    });
  };

  mappedUserInputHandler = (e, objectData) => {
    e.persist();
    this.setState(handleMappedUserInput(e, objectData), () => {
      const isEmail = e.target.name === "email";
      isEmail && this.validateEmail(e, objectData);

      if (
        //ako user upisuje oib, izbrisi sve ostale podatke

        objectData.group === "basicReviserData" &&
        e.target.name === "oib"
      ) {
        this.setState((prevState) => ({
          newFormData: {
            ...prevState.newFormData,
            [objectData.group]: [
              ...prevState.newFormData[objectData.group].map((element) =>
                element.id === objectData.id
                  ? {
                    //potrebno testirati
                    ...element,
                    ime: "",
                    regBroj: "",
                    prezime: "",
                    idOsobe: "",
                  }
                  : element
              ),
            ],
          },
        }));
      }
    });
  };

  multiplyComponent = (e, objData) => {
    e.persist();

    const lastElem = [...this.state.newFormData[objData.formGroup]];
    const addNewElement =
      (objData.formGroup === "officeAddress" && {
        ulicaKbr: "",
        nazNaselja: "",
        brPoste: "",
        nazivDrzave: "",
        sifDrzave: "191",
        id: lastElem[lastElem.length - 1].id + 1,
      }) ||
      (objData.formGroup === "basicReviserData" && {
        oib: "",
        prezime: "",
        ime: "",
        regBroj: "",
        idOsobe: "",
        // requiredFieldsRevData: ["oib", "prezime", "ime", "regBroj"],
        id: lastElem[lastElem.length - 1].id + 1,
      }) ||
      (objData.formGroup === "competentBodyData" && {
        vrRegistracije: "4",
        nazTijela: "",
        sifDrzave: "191",
        nazNaselja: "",
        brPoste: "",
        ulicaKbr: "",
        id: lastElem[lastElem.length - 1].id + 1,
      }) ||
      (objData.formGroup === "contactInformation" && {
        ime: "",
        prezime: "",
        telefon: "",
        web: "",
        email: "",
        emailValidated: false,
        id: lastElem[lastElem.length - 1].id + 1,
      }) ||
      (objData.formGroup === "reviserRegForeignCountry" && {
        vrRegistracije: "2",
        brReg: "",
        nazTijela: "",
        datReg: "",
        sifDrzave: "191",
        brPoste: "",
        ulicaKbr: "",
        nazNaselja: "",
        id: lastElem[lastElem.length - 1].id + 1,
      }) ||
      (objData.formGroup === "thirdCountryRegistration" && {
        vrRegistracije: "3",
        brReg: "",
        nazTijela: "",
        datReg: "",
        sifDrzave: "191",
        brPoste: "",
        ulicaKbr: "",
        nazNaselja: "",
        id: lastElem[lastElem.length - 1].id + 1,
      });
    this.setState((prevState) => ({
      newFormData: {
        ...prevState.newFormData,
        [objData.formGroup]: [
          ...prevState.newFormData[objData.formGroup],
          addNewElement,
        ],
      },
    }));
  };

  getReviserDataByOib = async (e) => {
    e.persist();

    const id = e.currentTarget.id;

    const stateCopy = { ...this.state.newFormData };
    const findReviserObject = stateCopy.basicReviserData.find(
      (element) => element.id == id
    );

    try {
      const { data } = await axiosInstance.get(
        `/sifarnici/osobe?oib=${findReviserObject.oib}`
      );

      if (data.length === 0) {
        this.props.formSubmitError(
          true,
          "Za OIB/identifikator koji ste unijeli nema dostupnih podataka o ovlaštenom revizoru! Unesite ispravan OIB/identifikator."
        );
        return;
      }

      //ovo je hardkodirano, potrebno vidjeti s bekendom u vezi ovoga
      let reviserObject = { ...findReviserObject };
      reviserObject.ime = data[0].ime;
      reviserObject.prezime = data[0].prezime;
      reviserObject.regBroj = data[0].regBroj;
      reviserObject.idOsobe = data[0].idOsobe;

      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          basicReviserData: [
            ...prevState.newFormData.basicReviserData.map((element) => {
              return element.id == id ? reviserObject : element;
            }),
          ],
        },
      }));
    } catch (e) {
      throw e;
    }
  };

  removeComponentHandler = (e, objectData) => {
    e.persist();
    const { formGroup } = objectData;
    const arrayLength = this.state.newFormData[formGroup].length;
    const id = e.currentTarget.id.replace(/[^0-9]/g, "");

    if (arrayLength > 1) {
      this.setState((prevState) => ({
        newFormData: {
          ...prevState.newFormData,
          [formGroup]: [
            ...prevState.newFormData[formGroup].filter(
              (element) => element.id != id
            ),
          ],
        },
      }));
    } else {
      alert("Uklanjanje nije moguće!");
    }
  };

  submitHandler = async (e) => {
    e.preventDefault();
    const { zahtjevAtrId } = this.props;

    const stateCopy = { ...this.state.newFormData };
    const { requiredFieldsUserData } = stateCopy.userData;
    const validateUserData = validateRequiredFields(
      stateCopy.userData,
      requiredFieldsUserData
    );

    let { requiredFieldsAddress } = stateCopy.address;
    if (stateCopy.address.sifDrzave != 191) {
      requiredFieldsAddress = ["nazNaselja", "permitDate", "permitNumber"];
    }
    const validateAddress = validateRequiredFields(
      stateCopy.address,
      requiredFieldsAddress
    );

    if (!validateUserData || !validateAddress) {
      this.setState(
        {
          error: true,
        },
        () => {
          this.props.formSubmitError(true, "Popunite obavezna polja!");
        }
      );
      return;
    }

    if (!stateCopy.userData.oibValidated) {
      this.props.formSubmitError(
        true,
        "OIB koji ste unijeli nije ispravan! (Osnovni podaci)"
      );
      return;
    }

    let userData = { ...stateCopy.userData };
    delete userData.requiredFieldsUserData;
    delete userData.oibValidated;
    delete userData.oznAkt;

    let address = { ...stateCopy.address };
    delete address.requiredFieldsAddress;

    let reg1Test = {
      vrRegistracije: "1",
      brReg: address.permitNumber,
      datReg: address.permitDate,
      sifDrzave: address.sifDrzave,
    };

    delete address.permitDate;
    delete address.permitNumber;

    const isEmailValidated = [...stateCopy.contactInformation].filter(
      (element) => !element.emailValidated && element.email.length > 0
    );

    if (isEmailValidated.length > 0) {
      this.setState({ error: true }, () => {
        this.props.formSubmitError(
          true,
          "E-mail koji ste upisali nije ispravan!"
        );
      });
      return;
    }

    //podaci o korisniku

    const contactInformation = [...stateCopy.contactInformation].map(
      (element) => {
        return {
          ime: element.ime,
          prezime: element.prezime,
          telefon: element.telefon,
          web: element.web,
          email: element.email,
        };
      }
    );
    const officeAddress = stateCopy.officeAddress.map((element) => {
      return {
        vrAdr: "2",
        ulicaKbr: element.ulicaKbr,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        sifDrzave: element.sifDrzave,
      };
    });

    const basicReviserData = stateCopy.basicReviserData.map((element) => {
      return {
        vrVeze: "1",
        idOsobe: element.idOsobe,
        oibOsobe: element.oib,
      };
    });

    const thirdCountryRegistration = stateCopy.thirdCountryRegistration.map(
      (element) => {
        return {
          vrRegistracije: element.vrRegistracije,
          brReg: element.brReg,
          nazTijela: element.nazTijela,
          datReg: element.datReg,
          sifDrzave: element.sifDrzave,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          nazNaselja: element.nazNaselja,
        };
      }
    );

    const reviserRegForeignCountry = stateCopy.reviserRegForeignCountry.map(
      (element) => {
        return {
          vrRegistracije: element.vrRegistracije,
          brReg: element.brReg,
          nazTijela: element.nazTijela,
          datReg: element.datReg,
          sifDrzave: element.sifDrzave,
          brPoste: element.brPoste,
          ulicaKbr: element.ulicaKbr,
          nazNaselja: element.nazNaselja,
        };
      }
    );

    const competentBodyData = stateCopy.competentBodyData.map((element) => {
      return {
        vrRegistracije: element.vrRegistracije,
        nazTijela: element.nazTijela,
        sifDrzave: element.sifDrzave,
        nazNaselja: element.nazNaselja,
        brPoste: element.brPoste,
        ulicaKbr: element.ulicaKbr,
      };
    });

    let addressArray = [];
    addressArray.push(address, ...officeAddress);
    let registrations = [];
    registrations.push(
      reg1Test,
      ...reviserRegForeignCountry,
      ...thirdCountryRegistration,
      ...competentBodyData
    );
    const { oznDokumenta } = this.state.newFormData;
    let submitData = [
      3,
      userData,
      addressArray,
      registrations,
      contactInformation,
      basicReviserData,
      oznDokumenta,
    ];

    try {
      this.setState({
        loader: true,
      });
      if (!this.state.update) {
        submitData.push([]);
        const res = await axiosInstance
          .post(`/unos/${zahtjevAtrId}`, submitData)
          .then(() =>
            this.setState({
              loader: false,
            })
          );
        this.props.formSubmitSuccess(
          false,
          "Podaci o subjektu uspješno upisani."
        );
        this.props.history.push("/odobrenje-zahtjeva");
        return;
      }
      submitData.push(stateCopy.mjere);
      const res = await axiosInstance.patch("/edit", submitData).then(() =>
        this.setState({
          loader: false,
        })
      );
      this.props.formSubmitSuccess(false, "Podaci uspješno ažurirani.");
      this.props.history.push("/pregled-registara");
    } catch (e) {
      this.props.formSubmitError(
        true,
        e.response.data.message ||
        "Nešto je pošlo po krivu, provjerite unesene podatke!"
      );
      this.setState({
        loader: false,
      });
    }
  };

  handleDayClick = (date, dateString, objData) => {
    this.setState(handleDayPicker(dateString, objData));
  };

  render() {
    const otherProps = {
      test: this.testHandler,
      userInputHandler: this.userInputHandler,
      parentState: { ...this.state },
      mappedUserInputHandler: this.mappedUserInputHandler,
      setCountryAutocompleteHandler: this.setCountryAutocompleteHandler,
      multiplyComponent: this.multiplyComponent,
      submitHandler: this.submitHandler,
      autocompleteCountryHandler: this.autocompleteCountryHandler,
      autocompleteCountyHandler: this.autocompleteCountyHandler,
      autocompleteCityHandler: this.autocompleteCityHandler,
      autocompleteDistrictHandler: this.autocompleteDistrictHandler,
      handleDayClick: this.handleDayClick,
      getReviserDataByOib: this.getReviserDataByOib,
      removeComponentHandler: this.removeComponentHandler,
    };

    return (
      <>
        {this.state.requestsLoaded ? (
          <EntryForm2 {...otherProps} />
        ) : (
          <Spinner />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    zahtjevAtrId: state.formData.zahtjevAtrId,
    idDrustva: state.update.idDrustva,
    vrDrustva: state.update.vrDrustva,
    oznDokumenta: state.update.oznDokumenta,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    formSubmitError: (error, notificationMessage) =>
      dispatch(formSubmitError(error, notificationMessage)),
    formSubmitSuccess: (error, notificationMessage) =>
      dispatch(formSubmitSuccess(error, notificationMessage)),
    purgeUpdate: () => dispatch({ type: PURGE_UPDATE }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegistarSamostalnihRevizora);
